import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ConfigWarning({ message, detail, link, linkText }) {
  const Wrapper = link ? Link : 'div';
  return (
    <Wrapper
      to={link}
      className="flex items-start gap-3 rounded-lg border border-warning/30 bg-warning/5 px-4 py-3 mb-4 no-underline transition-colors hover:bg-warning/10"
    >
      <AlertTriangle className="h-4 w-4 text-warning shrink-0 mt-0.5" />
      <div className="flex-1">
        <div className="text-xs font-semibold text-foreground">{message}</div>
        {detail && <div className="text-[11px] text-muted-foreground mt-0.5">{detail}</div>}
      </div>
      {linkText && <span className="text-xs text-primary font-medium shrink-0">{linkText}</span>}
    </Wrapper>
  );
}
